// 员工管理
import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 获取员工列表
export function getStaffList(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/employee',
    // url: 'http://192.168.0.107:5000/uims-oauth/employee',
    method: 'get',
    params
  })
}

// 获取可添加员工数量
export function getNum(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/employee/tenant/addable',
    // url: 'http://192.168.0.107:5000/uims-oauth/employee',
    method: 'get',
    params
  })
}

// 新增员工
export function addStaff(data) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/employee',
    // url: 'http://192.168.0.107:5000/uims-oauth/employee',
    method: 'post',
    data
  })
}
// 修改员工
export function editStaff(data) {
  return axios.request({
    // url: 'http://192.168.0.107:5000//uims-oauth/employee',
    url: urlObj.crm + 'uims-oauth/employee',
    method: 'put',
    data
  })
}
// 当前用户启用的角色列表
export function getRoleList(params) {
  return axios.request({
    // url: 'http://192.168.0.107:5000/uims-oauth/role/lister',
    url: urlObj.crm + 'uims-oauth/role/lister',
    method: 'get',
    params
  })
}
// 离职/在职
export function getinoffice(params) {
  return axios.request({
    // url: 'http://192.168.0.107:5000/uims-oauth/employee/inoffice',
    url: urlObj.crm + 'uims-oauth/employee/inoffice',
    method: 'put',
    params
  })
}

// 关闭账号
export function getstatus(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/employee/account/status',
    method: 'put',
    params
  })
}

// 重置密码
export function editPWD(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/employee/reset/pwd',
    method: 'put',
    params
  })
}

// 状态列表
export function getStatusList(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/dictionariesItem/getDictionariesItemList',
    method: 'get',
    params
  })
}

// 新增/修改
// export function addStaff(data) {
//   return axios.request({
//     url: urlObj.crm+ 'uims-oauth/authority/account/',
//     // url: 'http://192.168.0.107:5000//uims-oauth/authority/account/',
//     method: 'post',
//     data
//   })
// }
// 发送验证码
export function getVerification(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/authority/code/sms',
    method: 'get',
    params
  })
}
// 删除
export function delRole(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/authority/account/remove',
    method: 'get',
    params
  })
}

// 该用户"功能接口"是否有"限制用户数"，或者获取当前员工总数 ，员工数量上限
// export function getstaffNum(params) {
//   return axios.request({
//     url: urlObj.crm+ 'uims-oauth/authority/account/limit/users',
//     method: 'get',
//     params
//   })
// }
